import { Button } from '@talentmesh/ui/components/button';
import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import UIStrings from '@/Utils/UIStrings';

function CandidateInputFormHeader() {
    const { setPreviewInvitationEmailDialogOpen } = useInviteCandidateContext();

    return (
        <div className="flex flex-row flex-wrap items-center gap-2.5">
            <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline">
                <TypographyH3>{UIStrings.InvitationEmail}</TypographyH3>
                <TypographyP className="text-foreground font-normal md:inline">
                    {` - ${UIStrings.UsesTalentMeshBestPractices} `}
                </TypographyP>
            </div>
            <Button
                type="button"
                variant="outline"
                size="xs"
                className="text-secondary-foreground border-foreground shrink-0"
                onClick={() => setPreviewInvitationEmailDialogOpen(true)}
            >
                {UIStrings.Preview}
            </Button>
        </div>
    );
}

export default CandidateInputFormHeader;
